import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { NavigationService } from 'src/app/services/navigation.service';
import _ from 'lodash';
import { EnvironmentService } from 'src/app/services/environment.service';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from '../../services/constants.service';
import { LineitemService } from 'src/app/services/lineitem.service';
import { CollectPaymentComponent } from 'src/app/reusable-components/collect-payment/collect-payment.component';
import { PaymentService } from 'src/app/services/payment.service';
import { VariablesService } from 'src/app/services/variables.service';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})

export class PaymentComponent implements OnInit {


  
  programInfo: any;
  Total: 0;
  charges = {
    Conference: null,
    Hotel: null,
    Activity: null,
    Guest: null
  };
  attendee;
  isFormCompleted;
  isSubmitting;
  CCerrors;
  cardError;
  enrollment;
  mediatypes;
  payment;
  cards:any;
  fee;
  ready = false;
  showCancellation = false;
  track;

  constructor(private configurationService: ConfigurationService,
    private registrationService: RegistrationService,
    private navigationService: NavigationService,
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private constantsService: ConstantsService,
    private lineItemService: LineitemService,
    private paymentService: PaymentService,
    private variablesService: VariablesService) {
    this.payment = this.registrationService.getPayment([]);
    this.attendee = this.registrationService.getAttendee({});
    this.enrollment = this.registrationService.getEnrollment({});
    this.track = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varTrack.ID,
      {}
    );
    if ( this.attendee.PAXTypeNo === 27 || this.attendee.PAXTypeNo === 53 || this.attendee.PAXTypeNo === 54 ||
        this.track.Value === "Benefit Advisor" || this.track.Value === "Non-Benefit Advisor" || this.track.Value === "Commonwealth Client") {
      this.showCancellation = true;
    }
    
  }

  ngOnInit(): void {
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.mediaTranslations(this.programInfo);
    });

    this.paymentService.emitter.subscribe({
      next: (event) => {
        console.log(event);
        if(this.isFormCompleted){
          this.validateCards();
        }
      }
    });

    this.lineItemService.getAllLineItems().subscribe({
      next: data => {
        this.Total = 0;
        data.forEach((f)=>{
          this.Total += f.price * f.quantity;
        });
        this.ready = true;
        },
          error: error => {
            this.constantsService.ALERT_POLICY.CONTACT_SUPPORT
          }
    });

    for (const key of _.keys(this.charges)) {
      this.lineItemService.getLineItems(key).subscribe({
        next: data => {
          this.charges[key] = _.reduce(data, (sum, n) => {
            return parseFloat(sum) + parseFloat(n);
          });
          },
            error: error => {
              this.constantsService.ALERT_POLICY.CONTACT_SUPPORT
            }
      });
    }
  }

  /**
   * @function PaymentController.mediaTranslations
   * @describe Gets correct translations for displaying on the payment page.
   * @param otherPayment
   */
  mediaTranslations(programInfo) {
    if (programInfo.collectOtherPayment) {
      this.mediatypes = programInfo.mediatypes;
    } else {
      this.payment.forEach(element => {
        element.MediaType = "CREDITCARD";
      });
    }
  }

  /**
   * @function back
   * @description Uses [NavigationService.back()](./app.NavigationService.html) to go back to previous page.
   */

  back() {
    this.navigationService.back();
  }

  forward(form) {
    this.isFormCompleted = true;
    console.log(form);
    if (form.valid && !this.validateCards() && this.ready) {
      this.isSubmitting = true;
      this.navigationService.forward();
    }
  }

  validateCards() {
    this.CCerrors = [];
    this.cardError = false;
    console.log(this.payment);
    if (this.programInfo.decideCollect || this.Total > 0) {
      _.each(this.charges, (value, key) => {
        if (value > 0.00) {
          let card = this.registrationService.getCreditCard(this.payment, key, undefined);
          if (!card || !card.ReferenceKey && card.MediaType === "CREDITCARD") {
            console.log(key,card);
            this.cardError = true;
            this.CCerrors.push(key + " Card is required");
            card.$mtcerror = true;
          } else if (!card.MediaType) {
            this.cardError = true;
            this.CCerrors.push(key + " Payment Type is required");
            card.$mtcerror = true;
          }else{
            card.$mtcerror = false;
          }
        }
      });
    }

    if (this.needGuarantee()) {
      let card = this.registrationService.getCreditCard(this.registrationService.getPayment([]), "Guarantee", undefined);
      if(!card || !card.ReferenceKey){
        this.cardError = true;
        this.CCerrors.push("Credit card for registration Guarantee is required");
        card.$mtcerror = true;
      }else{
        card.$mtcerror = false;
      }
    }

    if (this.programInfo.hotelGuarantee && this.enrollment.HotelNeeded && (!this.charges.Hotel || this.charges.Hotel == 0)) {
      let card = this.registrationService.getCreditCard(this.registrationService.getPayment([]), "Hotel", undefined);
      if(!card || !card.ReferenceKey){
        this.cardError = true;
        card.$mtcerror = true;
        this.CCerrors.push("Hotel Guarantee Card is required");
      } else {
        card.$mtcerror = false;
      }
    }
    return this.cardError;
  }

  needGuarantee(){
    // if(!this.programInfo.otherPaymentRequireCC){
    //   return false;
    // }
    // let notCC = _.filter(this.payment, pay => {
    //   return pay.MediaType && pay.MediaType !== "CREDITCARD";
    // });
    // if (notCC.length > 0) {
    //   return true;
    // } else {
    //   return false;
    // }

    // console.log(this.charges);
    // console.log(this.programInfo.needsGuarantee);
    // console.log(this.programInfo.needsGuarantee && (this.charges.Conference == 0 || this.charges.Conference == undefined))
    return this.programInfo.needsGuarantee && (this.charges.Conference == 0 || this.charges.Conference == undefined);
  }
}
